import { render, staticRenderFns } from "./BranchUser.vue?vue&type=template&id=1f3dc4be&scoped=true&"
import script from "./BranchUser.vue?vue&type=script&lang=js&"
export * from "./BranchUser.vue?vue&type=script&lang=js&"
import style0 from "./BranchUser.vue?vue&type=style&index=0&id=1f3dc4be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3dc4be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
